var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingCleaningTaskBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_13996)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.188,
    y: -67.6067,
    width: 6,
    height: 113,
    transform: "rotate(45 56.188 -67.6067)",
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4307,
    y: -63.364,
    width: 6,
    height: 113,
    transform: "rotate(45 60.4307 -63.364)",
    fill: "#D0E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.6733,
    y: -59.1213,
    width: 6,
    height: 113,
    transform: "rotate(45 64.6733 -59.1213)",
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.916,
    y: -54.8787,
    width: 6,
    height: 113,
    transform: "rotate(45 68.916 -54.8787)",
    fill: "#D0E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.1584,
    y: -50.6362,
    width: 6,
    height: 113,
    transform: "rotate(45 73.1584 -50.6362)",
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.4011,
    y: -46.3936,
    width: 6,
    height: 113,
    transform: "rotate(45 77.4011 -46.3936)",
    fill: "#D0E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6438,
    y: -42.1509,
    width: 6,
    height: 113,
    transform: "rotate(45 81.6438 -42.1509)",
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.8865,
    y: -37.9082,
    width: 6,
    height: 113,
    transform: "rotate(45 85.8865 -37.9082)",
    fill: "#D0E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.1292,
    y: -33.6655,
    width: 6,
    height: 113,
    transform: "rotate(45 90.1292 -33.6655)",
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.3718,
    y: -29.4229,
    width: 6,
    height: 113,
    transform: "rotate(45 94.3718 -29.4229)",
    fill: "#D0E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.6145,
    y: -25.1802,
    width: 6,
    height: 113,
    transform: "rotate(45 98.6145 -25.1802)",
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.857,
    y: -20.9377,
    width: 6,
    height: 113,
    transform: "rotate(45 102.857 -20.9377)",
    fill: "#D0E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.1,
    y: -16.6951,
    width: 6,
    height: 113,
    transform: "rotate(45 107.1 -16.6951)",
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.342,
    y: -12.4524,
    width: 6,
    height: 113,
    transform: "rotate(45 111.342 -12.4524)",
    fill: "#D0E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.585,
    y: -8.20972,
    width: 6,
    height: 113,
    transform: "rotate(45 115.585 -8.20972)",
    fill: "#E8F2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_13996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 16,
    fill: "white",
    transform: "translate(0.285645 0.0700684)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCleaningTaskBackground);
export default __webpack_public_path__ + "static/media/pending-cleaning-task-background.c2dfd9a62e95a855af0cee875701619f.svg";
export { ForwardRef as ReactComponent };